import { render, staticRenderFns } from "./MenuHistorico.vue?vue&type=template&id=7adaa44c&"
import script from "./MenuHistorico.vue?vue&type=script&lang=js&"
export * from "./MenuHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports